export default __webpack_public_path__ + "static/media/selectedNotesLogo.4da1eb5c.svg";